const METRIKA_ID = process.env.REACT_APP_YANDEX_METRIKA_ID || '111973168';

let initialized = false;

export function initYandexMetrika() {
  if (!METRIKA_ID || initialized || typeof window === 'undefined') {
    return;
  }

  // Счётчик уже вставлен в public/index.html — не инициализируем повторно
  if (typeof window.ym === 'function') {
    initialized = true;
    return;
  }

  initialized = true;

  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    for (let j = 0; j < document.scripts.length; j += 1) {
      if (document.scripts[j].src === r) {
        return;
      }
    }
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`, 'ym');

  window.ym(Number(METRIKA_ID), 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: window.location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export function trackYandexMetrikaPage(path) {
  if (!METRIKA_ID || typeof window === 'undefined' || typeof window.ym !== 'function') {
    return;
  }

  window.ym(Number(METRIKA_ID), 'hit', path);
}

export function getYandexMetrikaId() {
  return METRIKA_ID;
}
